module.exports = __webpack_public_path__ + "img/modelo-pr2.bb51d234.png";